import { CommonService } from "./../../services/common.service";
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { ICourse } from "../../components/Shared/models/course";
import { environment } from "../../../environments/environment";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-all-courses",
  templateUrl: "./all-courses.component.html",
  styleUrls: ["./all-courses.component.css"],
})
export class AllCoursesComponent implements OnInit {
  @Input() courseList: Array<ICourse> = [];
  undergraduateCourses: Array<ICourse> = [];
  postgraduateCourses: Array<ICourse> = [];
  shortCourses: Array<ICourse> = [];
  @Input() isShowAll: boolean = false;
  url: string = environment.videoUrl;
  showShortCourses: boolean = false;
  groupedCourses: { [key: string]: any[] } = {};
  isFirstLogin: boolean = localStorage.getItem("IsFirstLogin") === "true";
  roleName: any = localStorage.getItem("RoleName");
  accordionStates: boolean[] = [];

  constructor(
    private route: Router,
    private CommonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    let windowUrl = window.location.href;
    if (windowUrl.includes("shortCourses")) {
      this.showShortCourses = true;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.courseList) {
      this.filterCourses();
    }
  }
  toggleAccordion(i: number) {
    this.accordionStates[i] = !this.accordionStates[i];
  }
  filterCourses() {
    this.courseList.sort((a, b) => a.COURSE_GRADUATION - b.COURSE_GRADUATION);

    if (this.showShortCourses) {
      this.groupedCourses = this.courseList
        .filter((course) => course.COURSE_GRADUATION === 3)
        .reduce((acc, course) => {
          if (!acc[course.COURSE_TYPE_NAME]) {
            acc[course.COURSE_TYPE_NAME] = [];
          }
          acc[course.COURSE_TYPE_NAME].push(course);
          return acc;
        }, {});
    } else {
      this.groupedCourses = this.courseList.reduce((acc, course) => {
        if (!acc[course.COURSE_TYPE_NAME]) {
          acc[course.COURSE_TYPE_NAME] = [];
        }
        acc[course.COURSE_TYPE_NAME].push(course);
        return acc;
      }, {});
      this.accordionStates = this.groupedCourses
        ? Object.keys(this.groupedCourses).map((_, index) => index === 0) // open first by default
        : [];
    }
    // this.CommonService.activateSpinner();
    // this.undergraduateCourses = this.courseList.filter(
    //   (course) => course.COURSE_GRADUATION === 1
    // );
    // this.postgraduateCourses = this.courseList.filter(
    //   (course) => course.COURSE_GRADUATION === 2
    // );
    // this.shortCourses = this.courseList.filter(
    //   (course) => course.COURSE_GRADUATION === 3
    // );
    // this.CommonService.deactivateSpinner();
  }
  courseGraduationOrder = (a: any, b: any) => {
    const firstCourseA = a.value[0]?.COURSE_GRADUATION || 0;
    const firstCourseB = b.value[0]?.COURSE_GRADUATION || 0;
    return firstCourseA - firstCourseB;
  };

  //[routerLink] ="['/view-course-details']"
  gotoCourseDetail(course: ICourse, Id: number) {
    this.CommonService.activateSpinner();
    if (Id == 1) {
      this.CommonService.postCall(
        "Registration/CheckShortCourseSubmittedByUser",
        {
          SHORTCOURSE_ID: course.COURSE_ID,
          SHORTCOURSE_USERID: localStorage.getItem("UserId"),
        }
      ).subscribe((res: any) => {
        if (res.message) {
          this.toastr.warning(
            "You have already applied for this Short Course. Please navigate to My Short Courses to access it."
          );

          return this.CommonService.deactivateSpinner();
        } else {
          if (sessionStorage.UserId) {
            localStorage.setItem("cID", course.COURSE_ID) as any;
            localStorage.setItem("cName", course.COURSE_NAME);
            localStorage.setItem("appTyp", course.COURSE_GRADUATION);
            localStorage.setItem("courseFee", course.COURSE_FEES);
            localStorage.setItem("softSkills", course.SOFT_SKILLS);
            localStorage.setItem("targetAUdience", course.TARGET_AUDIENCE);
            // this.route.navigate(["view-course-details"], { state: course });
            // this.route.navigate(["/OneApp/viewProgramDetails"], {
            //   state: course,
            // });
            let ApplicationType = localStorage.getItem("appTyp");
            if (ApplicationType == "3") {
              // this.route.navigate(["/OneApp/components/pdsRegForm"], {
              //   queryParams: { courseId: 0, isBool: true },
              // });
              this.route.navigate(["/OneApp/components/pdsRegForm"]);
              this.CommonService.deactivateSpinner();
            } else {
              this.CommonService.postCall("Registration/CheckUserByCourse", {
                USER_ID: localStorage.getItem("UserId"),
                COURSEID: localStorage.getItem("cID"),
                TNT_CODE: localStorage.getItem("TenantCode"),
              }).subscribe((res: any) => {
                if (res.registrationdetails == null) {
                  this.CommonService.postCall(
                    "Registration/CreateRegistrationDetailsFirst",
                    {
                      USER_ID: localStorage.getItem("UserId"),
                      COURSEID: localStorage.getItem("cID"),
                      CREATEDBY: localStorage.getItem("UserId"),
                      MODIFIEDBY: localStorage.getItem("UserId"),
                      TNT_CODE: localStorage.getItem("TenantCode"),
                    }
                  ).subscribe((res: any) => {
                    if (!this.isFirstLogin && ApplicationType != "3") {
                      this.route.navigate(["/OneApp/components/oukRegForm"]);
                    }
                    this.CommonService.deactivateSpinner();
                    // else if (ApplicationType == "3") {
                    //   this.route.navigate(["/OneApp/components/pdsRegForm"], {
                    //     queryParams: { courseId:localStorage.getItem("cID"), isBool: true },
                    //   });
                    // }
                  });
                } else if (
                  res.registrationdetails != null &&
                  ApplicationType != "3"
                ) {
                  if (
                    this.isFirstLogin &&
                    ApplicationType != "3" &&
                    this.roleName.toLowerCase() == "alumni"
                  ) {
                    this.route.navigate(["/OneApp/components/oukRegForm"]);
                    return this.CommonService.deactivateSpinner();
                  }
                  this.toastr.warning(
                    "Application already in progress, please navigate to My Application"
                  );
                  return this.CommonService.deactivateSpinner();
                } else {
                  setTimeout(() => {
                    this.CommonService.activateSpinner();
                    if (!this.isFirstLogin && ApplicationType != "3") {
                      this.route.navigate(["/OneApp/components/oukRegForm"]);
                      this.CommonService.deactivateSpinner();
                    }
                    //  else if (ApplicationType == "3") {
                    //   this.route.navigate(["/OneApp/components/pdsRegForm"], {
                    //     queryParams: { courseId: 0, isBool: true },
                    //   });
                    // }
                    else {
                      let payload = {
                        // "ACADEMICYEAR_ID":,
                        USER_ID: localStorage.getItem("UserId"),
                        TENANT_CODE: localStorage.getItem("TenantCode"),
                      };
                      this.CommonService.postCall(
                        "Registration/CheckMaxEnrollCourses",
                        payload
                      ).subscribe((res: any) => {
                        if (res.message == false) {
                          this.toastr.warning(
                            "You are not allowed to apply for more than 1 programmes. Please contact administrator for further details."
                          );
                          return this.CommonService.deactivateSpinner();
                        } else {
                          this.route.navigate(["OneApp/components/regForm"]);
                          this.CommonService.deactivateSpinner();
                        }
                      });
                    }
                    // this.CommonService.deactivateSpinner();
                  }, 1000);
                }
              });
            }
          }
        }
      });
    } else {
      if (sessionStorage.UserId) {
        localStorage.setItem("cID", course.COURSE_ID) as any;
        localStorage.setItem("cName", course.COURSE_NAME);
        localStorage.setItem("appTyp", course.COURSE_GRADUATION);
        localStorage.setItem("courseFee", course.COURSE_FEES);
        // this.route.navigate(["view-course-details"], { state: course });
        this.route.navigate(["/OneApp/viewProgramDetails"], { state: course });
        // (localStorage.setItem('CourseFee', course.COURSE_FEES) as any);

        // localStorage.setItem('ISCLUSTER', course.IS_CLUSTER);
      } else {
        // this.route.navigate(["eRP/view-course-details"], { state: course });
        this.route.navigate(["/OneApp/viewProgramDetails"], { state: course });
      }
    }
  }
}
